// commented colors are pale colors
export const COLORS_SERIES = [
    '#f45e29',
    '#80cc8c',
    '#4482ff',
    '#e46179',
    '#fa9e2d',
    // '#c6fbce',
    // '#aac6ff',
    '#ff926b',
    // '#ffacbb',
    // '#ffc37e',
    '#f79c3d',
    '#276ce6',
    '#da38b8',
    '#cc1845',
    // '#a0c44b',
    '#5b8ff9',
    // '#5ad8a6',
    '#5e7092',
    // '#f6bd18',
    '#6f5efa',
    // '#6ec8ec',
    '#945fb9',
    '#ff9845',
    '#299796',
    // '#fe99c3',
    // '#9fdef1',
    '#2a5d78',
    // '#b9e52f',
    '#e436bb',
    // '#ed90c7',
    '#34aeb1',
    '#8c5113',
    '#6197e2'
  ];